// Main  App.js  
//
import React, { useState , useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Link,  useNavigate, useLocation } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, CssBaseline, Box } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { initGA, logPageView } from './utils/analytics';
import posthog from 'posthog-js';
import Theme from './theme';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleCallback from './GoogleCallback';
import HeaderMenu from './utils/HeaderMenu';
import routeConfig from './routeConfig';
import { AuthProvider, useAuth } from './AuthContext';
import JobPage from './Jobs/JobPage';
import JobDetailPage from './Jobs/JobDetailPage';
import ApplyPage from './Jobs/ApplyPage';
import componentsMap from './utils/componentsMap';
import Login from './Login';
import ProfilePage from './extention/profilepage';
import Footer from './utils/Footer'
import Home from './Home';
import PageTracker from './utils/PageTracker';


const App = () => (
 // <GoogleOAuthProvider clientId="14388555053-la7s7phrsfaoemqnrusr4njrlijhd3ke.apps.googleusercontent.com">
  <AuthProvider>
    <Router>
      <MainApp />
    </Router>
  </AuthProvider>
 // </GoogleOAuthProvider>
);

const MainApp = () => {
  var { user, logout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedDarkMode);
  }, []);

  useEffect(() => {
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);
  
  useEffect(() => {
    posthog.capture('App Init', { property: 'value' })
    initGA(); // Initialize GA when app loads
  }, []);

  useEffect(() => {
    logPageView(location.pathname); // Log page view on route change
  }, [location]);

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);
  const handleLogout = () => {
    logout();
    // navigate('/login');
  };
  const handleToggleDarkMode = () => setDarkMode(!darkMode);
  if (!user) {
    user = { role: 'guest' };
  }
  /*
  useEffect(() => {
    console.log(user);
    if (user) {      
      const targetRoute = (() => {
        switch (user.role || '') {
          case 'admin': return '/admin/dashboard';
          case 'candidate': return '/candidate/profile';
          case 'client': return '/client/dashboard';
          case 'recruiter': return '/Candidates';
          default: return '/login';
        }
      })();
      
      if (location.pathname !== targetRoute && location.pathname === "/") {
        navigate(targetRoute);
      }
    }
  }, [user, navigate, location]);*/

  useEffect(() => {
    if (!user || !user.role) 
      user = { ...user, role: 'guest' }; // Avoid direct mutation

    const redirectPath = {
      admin: '/admin/dashboard',
      candidate: '/execedge',
      client: '/client/dashboard',
      recruiter: '/Candidates',
    //  guest: '/login',
    }[user.role] || '/login';

     if (location.pathname === '/' && user.role !== 'guest') navigate(redirectPath);
  }, [user, navigate, location]); 
    

  const renderRoute = (route, basePath = '') => {
    const fullPath = `${basePath}${route.path || ''}`.replace(/\/\//g, '/');
    const Component = componentsMap[route.component];

    if (route.children && route.roles.includes(user.role)) {
      return (
        <Route key={fullPath} path={fullPath} element={Component ? <Component /> : <Outlet />}>
          {route.children.map((childRoute) => renderRoute(childRoute, fullPath))}
        </Route>
      );
    } else if (Component && route.roles.includes(user.role)) {
      return <Route key={fullPath} path={fullPath} element={<Component />} />;
    } else if (Component) {
      return <Route key={fullPath} path={fullPath} element={<Login />} />;
    }
      else {
      return null;
      }
  };    return (
    <>
    <PageTracker />
       <ThemeProvider theme={Theme(darkMode)}>
       <CssBaseline enableColorScheme />
       <Box
      sx={{
        display: "flex",
        flexDirection: "column",        
        minHeight: "100vh", // Ensures the content stretches to full height
      }}
    >
          {user && (location.pathname !== '/login' ) && <HeaderMenu user={user} handleLogout={handleLogout} toggleDarkMode={handleToggleDarkMode} />}
       

      <Drawer open={drawerOpen} onClose={handleDrawerToggle}>
        <List>
          {routeConfig.map((route) => (
            <ListItem button component={Link} to={route.path} key={route.path}>
              <ListItemText primary={route.label} />
            </ListItem>
          ))}
        </List>
      </Drawer>

      
        <Routes>
          {routeConfig.map((route) => renderRoute(route))}
          <Route path="/login" element={<Login />} />
          <Route path="/jobs" element={<JobPage />} />
          <Route path="/jobs/:roleName" element={<JobDetailPage />} />
          <Route path="/apply/:roleName" element={<ApplyPage />} />
          <Route path="auth/google/callback" element={<GoogleCallback />} />          
          <Route path="/extension/:profileUrl" element={<ProfilePage />} />
          <Route path="/extension/*" element={<ProfilePage />} />
        </Routes>
     { (location.pathname !== '/login') && <Footer/>  }
    </Box>
    </ThemeProvider>

    </>
  );
};

export default App;
